import ky from 'ky';
import authState from '../store/auth';
import { get } from 'svelte/store';
const publicClient = ky.create({
    prefixUrl: 'https://api.pressone.co/api/',
    headers: { Accept: 'application/json' },
    credentials: 'include',
    retry: {
        limit: 0, // no retries
    },
    hooks: {
        afterResponse: [
            async (_req, _opt, response) => {
                if (!response.ok) {
                    response.data = await response.json();
                    return response;
                }
            },
        ],
    },
});
const privateClient = publicClient.extend({
    hooks: {
        beforeRequest: [
            async (request) => {
                const { accessToken } = get(authState);
                if (accessToken) {
                    request.headers.set('Pressone-X-Pub-Key', accessToken);
                }
                return request;
            },
        ],
    },
});
const PUBLIC_CLIENT = 'public';
const PRIVATE_CLIENT = 'private';
class Client {
    constructor() {
        this.publicClient = publicClient;
        this.privateClient = privateClient;
    }
    async request(method, url, level = 'private', payload, query) {
        const clientToUse = level === PRIVATE_CLIENT ? this.privateClient : this.publicClient;
        try {
            const response = await clientToUse(url, {
                method,
                searchParams: query,
                json: method.toUpperCase() === 'GET' ? undefined : payload,
            });
            return response.json();
        }
        catch (error) {
            console.dir(error);
            if (error.response) {
                const _error = error.response.data;
                throw _error;
            }
            else {
                const _error = {
                    code: 'INTERNAL_ERROR',
                    message: 'Something went wrong, Please check your internet connection and try again',
                    data: null,
                    status: false,
                };
                throw _error;
            }
        }
    }
    async get(...args) {
        return this.request('get', ...args);
    }
    async post(...args) {
        return this.request('post', ...args);
    }
    async patch(...args) {
        return this.request('patch', ...args);
    }
    async put(...args) {
        return this.request('patch', ...args);
    }
    async delete(...args) {
        return this.request('delete', ...args);
    }
}
export { PRIVATE_CLIENT, PUBLIC_CLIENT };
export default new Client();
